module.exports = __webpack_public_path__ + "static/img/77093E_3_4_C_20230430_LC.46744bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77093E_3_4_C_20230430_LC.png
// module id = npCx
// module chunks = 0